import pdfScreen from 'shared/components/lending/PdfScreen/PdfScreenStrings.en';

export default {
  pdfScreen,
};
